import TitleValue from '../Models/TitleValue';

abstract class OptimizationTypes {
  static readonly carry = new TitleValue('Carry', 'carry');
  static readonly total = new TitleValue('Total', 'total');
  static readonly combined = new TitleValue('Carry & Total', 'combined');
  static readonly high = new TitleValue('High Trajectory', 'high');
  static readonly medium = new TitleValue('Mid Trajectory', 'medium');
  static readonly low = new TitleValue('Low Trajectory', 'low');
}

export class OptimizationType {
  public static Carry = OptimizationTypes.carry;
  public static Total = OptimizationTypes.total;
  public static Combined = OptimizationTypes.combined;
  public static High = OptimizationTypes.high;
  public static Medium = OptimizationTypes.medium;
  public static Low = OptimizationTypes.low;
  public static c = OptimizationType.Carry;
  public static t = OptimizationType.Total;
  public static co = OptimizationType.Combined;
  public static h = OptimizationType.High;
  public static m = OptimizationType.Medium;
  public static l = OptimizationType.Low;
  public static C = OptimizationType.Carry;
  public static T = OptimizationType.Total;
  public static Co = OptimizationType.Combined;
  public static H = OptimizationType.High;
  public static M = OptimizationType.Medium;
  public static L = OptimizationType.Low;
}
export function GetOptimizationType(s: string): OptimizationType {
  switch (s.toLowerCase()) {
    case 'carry':
    case 'c':
      return OptimizationType.Carry;
    case 'total':
    case 't':
      return OptimizationType.Total;
    case 'combined':
    case 'co':
      return OptimizationType.Combined;
    case 'high':
    case 'h':
      return OptimizationType.High;
    case 'medium':
    case 'm':
      return OptimizationType.Medium;
    case 'low':
    case 'l':
      return OptimizationType.Low;
    default:
      return OptimizationType.Carry;
  }
}
